import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id 2C5308E6-760F-4CD8-A2CF-DD3B5434B0A0
 * name book-education-outline
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/book-education-outline.svg
 * tags
 */
export const BookEducationOutlineIcon = createSvgIcon(<><path d="M6 20H13V22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H18C19.11 2 20 2.9 20 4V12.54L18.5 11.72L18 12V4H13V12L10.5 9.75L8 12V4H6V20M24 17L18.5 14L13 17L18.5 20L24 17M15 19.09V21.09L18.5 23L22 21.09V19.09L18.5 21L15 19.09Z" /></>, 'BookEducationOutlineIcon');
export default BookEducationOutlineIcon